/**
 * PR-C1 (ADR-0035) Phase 1 — forward-chain видимость для кнопки «Вперёд»
 * на Калькуляторе.
 *
 * Конвенция ADR-0035: «Вперёд» на Калькуляторе видна ТОЛЬКО если для текущего
 * `projectId` уже существует КП вниз по цепочке. КП существует =
 *   - saved quote по `draftKey === projectId` (`pomoshnik-offline-v1.quotes`), ИЛИ
 *   - quote draft по ключу `projectId` (`quote-drafts` IDB).
 *
 * Любое из двух → true. Чистое чтение IDB (R2 — без persistence-изменений),
 * graceful: при ошибке возвращает false (кнопка скрыта), не throw.
 *
 * Логика живёт в state-слое feature (не в презентационной секции — ADR-0005).
 * Вызывается из `AnketaFormContainer`.
 */

import { loadLatestSavedQuoteByDraftKey } from './savedQuotesIdb';
import { loadQuoteDraftFromIdb } from './quoteDraftIdbSync';

/**
 * Возвращает true, если для `projectId` существует saved quote ИЛИ quote draft.
 * Пустой/standalone projectId → false (forward к КП не имеет смысла).
 */
export async function hasQuoteForProject(projectId: string): Promise<boolean> {
  if (!projectId || projectId === 'standalone') return false;
  try {
    const saved = await loadLatestSavedQuoteByDraftKey(projectId);
    if (saved) return true;
    const draft = await loadQuoteDraftFromIdb(projectId);
    return draft !== undefined;
  } catch {
    // graceful: IDB недоступен → кнопка скрыта (как остальные IDB-paths проекта)
    return false;
  }
}
